module.exports = __webpack_public_path__ + "img/count-04.b5e36f75.png";